module.exports = __webpack_public_path__ + "static/media/YB5M07_1.a4081cf9.jpg";